import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { GetEnglishOrArabic } from "../../";

import { Radio, Checkbox, Row, Col, Tag } from "antd";
import {
  MinusCircleOutlined,
  PlusCircleOutlined,
  SlidersOutlined,
  HolderOutlined,
  LeftOutlined,
  SelectOutlined,
  MoreOutlined,
} from "@ant-design/icons";

import { getProductInventory } from "../../../../store/reducers/pos";
import { Button } from "antd";

export class OptionChoice extends Component {
  state = { radioValue: this.props.choice.id };
  getIsOutOfStock = () => {
    const {
      usedComponents,
      editedProduct,
      choice,

      option,
    } = this.props;
    const totalUsedComponents = { ...usedComponents };
    return (
      !editedProduct?.options[option.id]?.selectedOptions?.[choice.id] &&
      getProductInventory(choice.related_product, totalUsedComponents) <= 0
    );
  };

  handleChoiceClick = (addOption, quantity, quantityDifference) => {
    const {
      choice,
      option,
      productQuantity,
      productUsedComponents,
      usedComponents,
      editedProduct,
      groupID,
    } = this.props;
    if (
      quantityDifference > 0 &&
      choice.related_product &&
      choice.inventory !== null
    ) {
      const totalUsedComponents = { ...usedComponents };

      Object.entries(editedProduct?.usedComponents || {}).forEach(
        ([optionId, optionQuantity]) => {
          const newOptionId = optionId.toString().replace("Q", "");
          totalUsedComponents[newOptionId] =
            (totalUsedComponents[newOptionId] || 0) -
            optionQuantity *
              ((optionId.toString().includes("Q") && 1) ||
                editedProduct?.quantity);
        },
      );

      Object.entries(productUsedComponents).forEach(
        ([optionId, optionQuantity]) => {
          const newOptionId = optionId.toString().replace("Q", "");
          totalUsedComponents[newOptionId] =
            (totalUsedComponents[newOptionId] || 0) +
            optionQuantity *
              ((optionId.toString().includes("Q") && 1) || productQuantity);
        },
      );
      const choiceInventory = getProductInventory(
        choice.related_product,
        totalUsedComponents,
      );

      if (
        choiceInventory <
        quantityDifference *
          ((option.quantity_exclusive && 1) || productQuantity)
      )
        return;
    }
    this.props.addOptionToProduct(
      this.props.choice,
      this.props.option,
      quantity,
      quantityDifference,
      addOption,
      groupID,
    );
  };

  render() {
    const {
      t,
      option,
      choice,
      selectedOverall,
      settings,
      selected,
      config,
      hasChildren,

      onOpenConditionalModal,
      groupID,
    } = this.props;
    const quantity = Number(selected) || 0;
    const is_radio_option = option.maximum === 1;
    const increments = Math.max(parseInt(choice.increments) || 1, 1);

    const is_multiple = option.multiple && option.maximum !== 1;

    const currency =
      config.language === "arabic"
        ? settings.currency_local
        : settings.currency_english;

    const isOutOfStock = choice.inventory !== null && this.getIsOutOfStock();

    return (
      <Row
        onClick={() => {
          if (isOutOfStock) return;
          if (is_radio_option) {
            const newSelected = !selected;
            if (!option.is_required || newSelected) {
              this.handleChoiceClick(newSelected, parseInt(newSelected * 1), 1);
              this.props.setRadioValue((newSelected && choice.id) || null);
            }
          } else {
            const checked = !selected;
            if (
              (selectedOverall + increments <= (option.maximum || Infinity) &&
                increments <= (choice.maximum || Infinity)) ||
              !checked
            ) {
              this.handleChoiceClick(
                checked,
                checked ? increments : 0,
                checked ? increments : -quantity,
              );
            }
          }
        }}
        className={`mx-auto my-3 OptionChoiceContainer ${
          selected && "OptionChoiceContainerSelected"
        }`}
        style={{
          cursor: !isOutOfStock && "pointer",
          border: "1px solid #d9d9d9",
          width: "100%",
          minHeight: 55,
          opacity: (isOutOfStock && 0.3) || 1,
          alignItems: "center",
        }}
      >
        {/* 1) selector */}
        <Col span={2} style={{ display: "flex", justifyContent: "center" }}>
          {is_radio_option ? (
            <Radio value={choice.id} checked={!!selected} />
          ) : (
            <Checkbox checked={!!selected} />
          )}
        </Col>

        {/* 2) label */}
        <Col
          span={10}
          style={{
            paddingTop: 12,
            paddingBottom: 12,
            display: "flex",
            flexDirection: "column",
            gap: 6,
            alignItems: "center",
          }}
        >
          {!choice.is_active && <Tag>{t("Hidden from store")}</Tag>}
          <p
            style={{ textAlign: "center", margin: 0, wordBreak: "break-word" }}
          >
            {GetEnglishOrArabic(choice.value, choice.ar_value, config.language)}
          </p>
        </Col>

        {/* 3) price */}
        <Col span={4} style={{ display: "flex", justifyContent: "center" }}>
          <p style={{ whiteSpace: "nowrap", margin: 0, fontSize: "12px" }}>
            {`${choice.price.toFixed(settings.currency_decimals)}`}
            <span style={{ whiteSpace: "break-spaces" }}> {currency}</span>
          </p>
        </Col>

        {/* 4) counter area (always reserved width) */}
        <Col span={6} style={{ display: "flex", justifyContent: "center" }}>
          {is_multiple ? (
            <div
              className="disable-select"
              onClick={(e) => e.stopPropagation()}
              style={{ display: "flex", alignItems: "center", gap: 10 }}
            >
              <MinusCircleOutlined
                style={{ fontSize: 25, color: "#0099CC" }}
                onClick={() => {
                  let newQuantity = quantity;
                  if (!newQuantity) return;
                  let newSelected = selected;
                  newQuantity -= increments;
                  if (newQuantity <= 0) {
                    newQuantity = 0;
                    newSelected = false;
                  }
                  const quantityDifference = newQuantity - quantity;
                  this.handleChoiceClick(
                    newSelected,
                    newQuantity,
                    quantityDifference,
                  );
                }}
              />
              <span style={{ width: 32, textAlign: "center" }}>{quantity}</span>
              <PlusCircleOutlined
                style={{ fontSize: 25, color: "#0099CC" }}
                onClick={() => {
                  if (
                    selectedOverall + increments <=
                      (option.maximum || Infinity) &&
                    quantity + increments <= (choice.maximum || Infinity)
                  ) {
                    let newQuantity = quantity + increments;
                    this.handleChoiceClick(true, newQuantity, increments);
                  }
                }}
              />
            </div>
          ) : (
            <div style={{ height: 1 }} />
          )}
        </Col>

        {/* 5) child “>” button area (always reserved width) */}

        <Col span={2} style={{ display: "flex", justifyContent: "center" }}>
          {hasChildren ? (
            <Button
              type="link"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onOpenConditionalModal(choice, groupID);
              }}
              className={`OptionChoiceContainer ${
                selected && "OptionChoiceContainerSelected"
              }`}
              style={{
                width: "100%",
                border: "0px solid #d9d9d9",
                fontWeight: "bold",
                minHeight: 55,
                padding: 0,
                lineHeight: "30px",
                textAlign: "center",
              }}
              icon={
                selected > 0 ? (
                  <MoreOutlined
                    style={{
                      fontSize: "24px",
                      color: "#0099CC",
                      marginTop: "4px",
                    }}
                  />
                ) : (
                  <MoreOutlined
                    style={{
                      fontSize: "20px",
                      color: "#666",
                      marginTop: "4px",
                    }}
                  />
                )
              }
            />
          ) : (
            <div style={{ width: "100%", height: 1 }} />
          )}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  settings: state.auth.settings,
  config: state.config,
  usedComponents: state.pos.usedComponents,
});

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withNamespaces()(OptionChoice));
